import src from "IMAGE";
export default { src, width: 3680, height: 910, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAP0lEQVR42h3IYQqAIAyAUe9/RZUWOdiYMzvBV/TrwSuxgtyLfG7mTnw6nv5rYRQZwjDFvlBX+tnoUpGr047KC7PfOznmp39IAAAAAElFTkSuQmCC"};
